import request from '@/config/request.js'
const ApiRenewal = request.Renewal
import common from '@/components/common/'
import ExpenseForm from './Form/index.vue'
import RenewForm from './renewForm/index.vue'
import setting from "@/config/settings";
import moment from 'moment';
export default {
  name: 'expense-details',
  components: {
    ...common,
    ExpenseForm,
    RenewForm
  },
  data () {
    return {
      qiniu: setting.gbs.qiniu,
      loadtext: '正在加载中',
      listLoading: false,
      search_data: {
        filters: []
      },
      seachShow: false,
      // 需要给分页组件传的信息
      paginations: {
        current_page: parseInt(this.$route.query.page) || 1,
        total: 0,
        page_size: 10
      },
      tableList: [],
      formLabelWidth: '120px',
      chooseTagOptions: [
        {enCode: 'MEALS', Text: '学生餐食'},
        {enCode: 'FRUIT_CUP', Text: '水果点心'},
        {enCode: 'STUDENT_GIFTS', Text: '学生礼品'},
        {enCode: 'TEACHIMG_AIDS', Text: '办公用品'},
        {enCode: 'CAMPAIGN', Text: '宣传活动'},
        {enCode: 'REPAIR', Text: '日常维修'},
        {enCode: 'WAGE', Text: '薪酬福利'},
        {enCode: 'COMMUNICATION', Text: '通讯交通'},
        {enCode: 'UTILITIES', Text: '水电煤气'},
        {enCode: 'RENT_PROPERTY', Text: '房租物业'},
        {enCode: 'PURCHASE_EQUIPMENT', Text: '固定资产'},
        {enCode: 'MISCELLANEOUS', Text: '低值易耗'},
        {enCode: 'INTRODUCING_COURSES', Text: '课程账号'},
        // {enCode: 'REFUND', Text: '学生退费'},
        {enCode: 'OTHER', Text: '其他'},
      ],
      formVisible: false,
      expenditure: [],
      renewFormVisible: false,
    }
  },
  computed: {
    tableHight: function () {
      return window.innerHeight - 255
    },
    loading: function () {
      return this.$store.state.global.ajax_loading
    }
  },
  methods: {
    onDelete (row) {
      this.$confirm('确定删除该记录吗, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        ApiRenewal.deleteBatch.call(this, {id: row.id}, (res => {
          this.initData();
        }))
      })
    },

    getRowDetails (row = {}) {
      let that  = this
      this.renewFormVisible = true
      this.$nextTick(() => {
        console.log(this.$refs)
        that.$refs.RenewForm.init(row)
      })
    },
    getRowEdit (row = {}) {
      let that  = this
      this.formVisible = true
      this.$nextTick(() => {
        console.log(this.$refs)
        const isEmpty = !row || (Object.keys(row).length === 0 && row.constructor === Object)
        that.$refs.ExpenseForm.init(isEmpty ? undefined : [row])
      })
    },
    onResetSearch () {
      this.initData()
    },
    /**
     * 搜索事件
     */
    onSearch () {
      this.initData()
    },
    exportAccountSpending () {
      this.listLoading = true;
      var data = {
        offset: (this.paginations.current_page - 1) * this.paginations.page_size,
        limit: this.paginations.page_size,
        data: null,
        filters: null,
        orFilters: null,
        order: 'desc',
        sort: 'recordDate'
      }
      let search = {
        filters: []
      }
      this.search_data.filters.map(item => {
        if (item.value) {
          search.filters.push(item)
        }
      })
      let _query = {
        ...data,
        ...search,
      };
      ApiRenewal.getRenewalTaskPage.call(this,_query, (res => {
        window.open(res.result)
        this.listLoading = false;
      }), false,err => {
        this.listLoading = false;
      })
    },
    initData () {
      this.listLoading = true;
    
      var data = {
        offset: (this.paginations.current_page - 1) * this.paginations.page_size,
        limit: this.paginations.page_size,
        data: null,
        filters: null,
        order: '',
        sort: ''
      }
      
      let _query = {
        ...data
      };

      ApiRenewal.getRenewalTaskPage.call(this,_query, (res => {
        this.tableList = res.content
        console.log(this.tableList)
        this.paginations.total = parseInt(res.totalElements)
        this.listLoading = false;
      }))
    },
    
  },
  mounted () {
    this.initData()
  }
}
